import { render, staticRenderFns } from "./report-AI-bianzheng.vue?vue&type=template&id=b0294fb0&scoped=true&"
import script from "./report-AI-bianzheng.vue?vue&type=script&lang=ts&"
export * from "./report-AI-bianzheng.vue?vue&type=script&lang=ts&"
import style0 from "./report-AI-bianzheng.vue?vue&type=style&index=0&id=b0294fb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0294fb0",
  null
  
)

export default component.exports